import PlatesProvider from '@/application/providers/PlatesProvider'
import Util from  '@/application/libs/util'
import {validationFunctions as vf} from  '@/application/libs/validations'
import {validateFields, getFormatedError as _getFormatedError} from  '@/application/libs/validations'
import { t } from 'i18next'

const _getNRORG = () => Util.getLocalVar('userData').NRORG;
const _getCDFILIAL = () => Util.getFilterInSession().CDFILIAL;
const _getCDSERVFILI = () => Util.getFilterInSession().CDSERVFILI;
const _getDTMESCARD = () => Util.getFilterInSession().DTMESCARD;
const _getIDTIPORESTRICAO = () => Util.getFilterInSession().TPCONTRATO;



function PlatesService() {

    const _getValueFromRow = (row, keyName, fallbackKey) => {
        return row[keyName + "_key"] === null ? row[keyName + "_key"] : row[keyName + "_key"] || row[fallbackKey] || row[keyName];  
    }

    const getAtratividadePrato = (source, target, currentCDFILIAL, initialCDFILIAL, withName = false) => {
        const isSameFilial = currentCDFILIAL === initialCDFILIAL;
        const isExportingAtratividade = source.hasOwnProperty('NRATRATIVIDADEPRATO');
        const shouldExportAtratividade = isSameFilial && isExportingAtratividade;
        let ret = {};
        ret.NRATRATIVIDADEPRATO = shouldExportAtratividade ? source.NRATRATIVIDADEPRATO || null : 
            _getValueFromRow(target, "NMATRATIVIDADEPRATO", "NRATRATIVIDADEPRATO") || null;
        if(withName){
            ret.NMATRATIVIDADEPRATO = shouldExportAtratividade ? source.NMATRATIVIDADEPRATO || null : 
                target.NMATRATIVIDADEPRATO || null
        }
        return ret;
    };

    this.getValueFromRow = _getValueFromRow;
    
    this.exportParameters = ({source, targets = [], fullSource, initialCDFILIAL} = {}) => {
        let sourceFormatted = Util.arrayToOjbect(source);

        const [CDFILIAL, NRORG] = [_getCDFILIAL(), _getNRORG()];
        
        const changedData = targets.map(t => ({ //merge data
            ...t,
            ...sourceFormatted,
            ...getAtratividadePrato(sourceFormatted, t, CDFILIAL, initialCDFILIAL),  
            CDPRATO: t.CDPRATO, 
            CDFILAUXPRAT: t.CDFILAUXPRAT}));
        const dataToSave = changedData.map(target => ({ //format data
            CDAPRERECE: target.CDAPRERECE,
            CDFILAUXPRAT: target.CDFILAUXPRAT,
            CDFILIAL: CDFILIAL,
            CDPRATO: target.CDPRATO,
            IDCOMPLEXIDADE: target.IDCOMPLEXIDADE,
            IDCOR: target.IDCOR,
            IDPREPREPARO: target.IDPREPREPARO,
            NRATRATIVIDADEPRATO: target.NRATRATIVIDADEPRATO,
            NRFORMAPREPARO: target.NRFORMAPREPARO,
            NRINGREDIENTEPRINC1: target.NRINGREDIENTEPRINC1,
            NRINGREDIENTEPRINC2: target.NRINGREDIENTEPRINC2,
            NRTIPOPROTEINA: target.NRTIPOPROTEINA,
            NRORG: NRORG,
            PRATO_PARAMETRIZADO: target.PRATO_PARAMETRIZADO
        }));

        return PlatesProvider.saveChangedData(dataToSave, 'PARAMPRAT').then(() => {
            const fullSourceObj = Util.arrayToOjbect(fullSource);
            return targets.map(t => ({ //merge data
                ...t,
                ...fullSourceObj,
                ...getAtratividadePrato(sourceFormatted, t, CDFILIAL, initialCDFILIAL, true),
                CDPRATO: t.CDPRATO, 
                CDFILAUXPRAT: t.CDFILAUXPRAT,
                PRATO_PARAMETRIZADO: "S"}));
        });
        
    };

    this.exportParametersToAnyFilial = async ({source, targets = [], initialCDFILIAL, auxData} = {}) => {
        const camposEsperados = [
            "IDCOMPLEXIDADE",
            "IDPREPREPARO", 
            "IDCOR",
            "NMINGREDIENTEPRINC1",
            "NMINGREDIENTEPRINC2",
            "TIPOCORTE",
            "NMFORMAPREPARO",
            "NMATRATIVIDADEPRATO",
            "NMTIPOPROTEINA"
        ];

        const sourceKeys = [];
        if (source && Array.isArray(source)) {
            source.forEach(item => {
                const key = Object.keys(item)[0];
                sourceKeys.push(key);
            });
        }

        const exportFields = {};
        camposEsperados.forEach(campo => {
            exportFields[campo] = sourceKeys.includes(campo) ? 'S' : 'N';
        });
    
        const pratos = targets.map(item => (
            item.CDFILAUXPRAT + item.CDPRATO
        ));

        const data = {
            CDFILIAL_ORIGEM: initialCDFILIAL,
            EXPORT_FIELDS: exportFields,
            PRATOS: pratos,
            FILIAL_LIST: !auxData.allSelected ? auxData.selectedUnits.join('_') : 'T',
            MODE: auxData.mode
        }

        return await PlatesProvider.exportPlatesProcedure(data);        
    };

    /**
     * Save changed data on the main grid, to
     * register that are related with main filter.
     */
    this.saveParametersGridData = (changedData, CDFILIAL, NRORG) => {
        if (!Array.isArray(changedData)) {
            changedData = [changedData];
        }
        changedData = changedData.map(e => {
            return {
                CDAPRERECE: _getValueFromRow(e, "TIPOCORTE", "CDAPRERECE") || null, //e.TIPOCORTE_key || e.CDAPRERECE,
                CDFILAUXPRAT: e.CDFILAUXPRAT_key || e.CDFILAUXPRAT,
                CDFILIAL: CDFILIAL,
                CDPRATO: _getValueFromRow(e, "CDPRATO"),
                IDCOMPLEXIDADE: _getValueFromRow(e, "IDCOMPLEXIDADE"),
                IDCOR: _getValueFromRow(e, "IDCOR"),
                IDPREPREPARO: _getValueFromRow(e, "IDPREPREPARO"),
                NRATRATIVIDADEPRATO: _getValueFromRow(e, "NMATRATIVIDADEPRATO", "NRATRATIVIDADEPRATO") || null,
                NRFORMAPREPARO: _getValueFromRow(e, "NMFORMAPREPARO", "NRFORMAPREPARO"),
                NRINGREDIENTEPRINC1: _getValueFromRow(e, "NMINGREDIENTEPRINC1", "NRINGREDIENTEPRINC1"),
                NRINGREDIENTEPRINC2: _getValueFromRow(e ,"NMINGREDIENTEPRINC2", "NRINGREDIENTEPRINC2"),
                NRTIPOPROTEINA: _getValueFromRow(e ,"NMTIPOPROTEINA", "NRTIPOPROTEINA"),
                NRORG: NRORG,
                PRATO_PARAMETRIZADO: _getValueFromRow(e, "PRATO_PARAMETRIZADO")
            }
        })
        // let validations = {
        //     NMINGREDIENTEPRINC1: {
        //         f:vf.withAnother(
        //             vf.optionalFunc(
        //                 vf.different("NRINGREDIENTEPRINC2", "Ingrediente Principal 2"),
        //                 [null] // consider null as empty
        //             ),
        //             "NRINGREDIENTEPRINC1",
        //             "Ingrediente Principal 1" 
        //         ),
        //         label: ""
        //     },
        //     NMINGREDIENTEPRINC2: {
        //         f: vf.withAnother( 
        //             vf.optionalFunc(
        //                 vf.different("NRINGREDIENTEPRINC1", "Ingrediente Principal 1"),
        //                 [null] // consider null as empty
        //             ),
        //             "NRINGREDIENTEPRINC2",
        //             "Ingrediente Principal 2"
        //         ),
        //         label: ""
        //     }
        // }
        const validationResult = validateFields(changedData[0]/*, validations*/, {});
        if(!validationResult.error){
            return PlatesProvider.saveChangedData(changedData, 'PARAMPRAT');
        } else {
            return Promise.reject(validationResult);
        }
    };

    this.saveGroupPlates = (changedData, NRORG) => {
        let formatedValue = {
            CDFILAUXPRAT : _getValueFromRow(changedData ,"CDFILAUXPRAT"),
            CDPRATO : _getValueFromRow(changedData ,"CDPRATO"),
            NRGRUPOPRATOSERV : _getValueFromRow(changedData, "NMGRUPOPRATO" ,"NRGRUPOPRATOSERV"),
            NRITGRUPOPRATOSERV : _getValueFromRow(changedData , "NRITGRUPOPRATOSERV"),
            CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR,
            NRORG: NRORG
        }
        if (changedData.NRITGRUPOPRATOSERV) {
            return PlatesProvider.saveChangedData([formatedValue], 'PARAMPRATGRUPPRAT');
        } else {
            return PlatesProvider.insertData([formatedValue], 'PARAMPRATGRUPPRAT');
        }
    };

    this.saveAttractivenessGridData = (changedData, CDFILIAL, colName) => {
        let validations = {
            NMATRATIVIDADEPRATO: { f: vf.notEmpty, label: t('description_of_attractiveness')},
            VRPESOATRATIVIDADE: { f: vf.numericalPositiveInteger, label: "peso" }
        };
        let validationResult = validateFields(changedData, validations);
        if (!validationResult.error) {
            if (changedData.NRATRATIVIDADEPRATO) {
                return PlatesProvider.saveChangedData([changedData], 'ATRATIVIDADE');
            } else {
                return PlatesProvider.insertData([{
                    NMATRATIVIDADEPRATO: changedData.NMATRATIVIDADEPRATO,
                    VRPESOATRATIVIDADE: changedData.VRPESOATRATIVIDADE,
                    CDFILIAL: CDFILIAL,
                    NRORG: _getNRORG()
                }], 'ATRATIVIDADE');
            }
        } else {
            return Promise.resolve(_getFormatedError(changedData, validations, colName, !changedData.NRATRATIVIDADEPRATO));
        }
    };

    this.deleteAttractivenessGridData = (data) => {
        return PlatesProvider.deleteData(data.filter(el => el.NRATRATIVIDADEPRATO).map(de => {
            return { NRATRATIVIDADEPRATO: de.NRATRATIVIDADEPRATO }
        }), "ATRATIVIDADE");
    };

    this.savePreparationMethodGridData = (changedData, colName) => {
        let validations = {
            NMFORMAPREPARO: { f: vf.notEmpty, label: t('cooking_method_name') }
        };
        let validationResult = validateFields(changedData, validations);
        if (!validationResult.error) {
            if (changedData.NRFORMAPREPARO) {
                return PlatesProvider.saveChangedData([changedData], 'MDPREPARO');
            } else {
                return PlatesProvider.insertData([{
                    NMFORMAPREPARO: changedData.NMFORMAPREPARO,
                    NRORG: _getNRORG(),
                }], 'MDPREPARO');
            }
        } else {
            return Promise.resolve(_getFormatedError(changedData, validations, colName, !changedData.NRFORMAPREPARO));
        }
    };

    const _getFormatedError = (changedData, validations, colName, isNew, forceFullValidation = false) => {
        let res = null;
        let keys = Object.keys(validations);
        // full row validation
        if(!isNew || keys.indexOf(colName) === keys.length - 1 || forceFullValidation){ // do full validation 
            res = validateFields(changedData, validations);
        } else if(validations[colName]){ // only do full validation on last field edit
            let singleColValidation = {};
            singleColValidation[colName] = validations[colName];
            res = validateFields(changedData, singleColValidation);
            res = res === true ? null : res;
        }
        return res;
    };
    this.saveCutTypeGridData = (changedData, colName) => {
        let validations = {
            CDAPRERECE: { 
                f: [vf.notEmpty, vf.regex(/^\d+$/, t('the_field_must_only_contain_numbers')), vf.maxLength(3)], 
                label: t('cut_type_code') 
            },
            TIPOCORTE: { f: vf.notEmpty, label: t('cut_type_name') }
        };
        let validationResult = validateFields(changedData, validations);
        if (!validationResult.error) {
            let formatedValue = {
                NMAPRERECE: changedData.TIPOCORTE,
                CDAPRERECE: changedData.CDAPRERECE.padStart(3, 0)
            };
            if (changedData.IS_NEW === "false") {
                return PlatesProvider.saveChangedData([formatedValue], 'TPCORTE');
            } else {
                return PlatesProvider.insertData([formatedValue], 'TPCORTE');
            }
        } else {
            return Promise.resolve(_getFormatedError(changedData, validations, colName, changedData.IS_NEW !== "false"));
        }
    };
    this.saveMainIngredientGridData = (changedData, colName) => {
        let validations = {
            NMINGREDIENTEPRINC: { f: vf.notEmpty, label: t('cooking_method_name') }
        };
        let validationResult = validateFields(changedData, validations);
        if (!validationResult.error) {
            if (changedData.NRINGREDIENTEPRINC) {
                return PlatesProvider.saveChangedData([changedData], 'INGRPRINC');
            } else {
                return PlatesProvider.insertData([{
                    NMINGREDIENTEPRINC: changedData.NMINGREDIENTEPRINC,
                    NRORG : _getNRORG()
                }], 'INGRPRINC');
            }
        } else {
            return Promise.resolve(_getFormatedError(changedData, validations, colName, !changedData.NRINGREDIENTEPRINC));
        }
    };

    this.saveTypeProteinGridData = (changedData, colName) => {
        let validations = {
            NMTIPOPROTEINA: { f: vf.notEmpty, label: t('cooking_method_name') }
        };
        let validationResult = validateFields(changedData, validations);
        if (!validationResult.error) {
            if (changedData.NRTIPOPROTEINA) {
                return PlatesProvider.saveChangedData([changedData], 'TPPROTEINA');
            } else {
                return PlatesProvider.insertData([{
                    NMTIPOPROTEINA: changedData.NMTIPOPROTEINA,
                    NRORG : _getNRORG()
                }], 'TPPROTEINA');
            }
        } else {
            return Promise.resolve(_getFormatedError(changedData, validations, colName, !changedData.NRINGREDIENTEPRINC));
        }
    };
    this.saveCombinationGridData = (changedData, colName, CDFILIAL, CDSERVFILI, IDTIPORESTRICAO) => {
        let validations = {
            PERCENTREDUCAO: {
                f: vf.optional(
                    vf.range(0, 99, t('the_reduction_percentage_field_must_be_a_number_between_0_and_99'))
                ), 
                label: t('reduction_percentage') 
            },
            // NMGRTIPOPR: {f: vf.withAnother(vf.notEmpty, "CDGRTIPOPR", "Código do Grupo do Tipo de Prato"), label: ""},
            // NMPRATO: {f: vf.withAnother(vf.notEmpty, "CDPRATO", "Código do Prato"), label: ""},
            // COMB_NMGRTIPOPR: {f: vf.withAnother(vf.notEmpty, "COMB_CDGRTIPOPR", "Código do Grupo do Tipo de Prato"), label: ""},
            // COMB_NMPRATO: {f: vf.withAnother(vf.notEmpty, "COMB_CDPRATO", "Código do Prato"), label: ""},
            // IDCOMBINACAO: {f: vf.notEmpty, label: "Tipo de Combinação"},
        };
        let validationResult = validateFields(changedData, validations);
        changedData.lastColTouched = changedData.lastColTouched || colName === "IDCOMBINACAO";
        if (!validationResult.error) {
            if (!changedData.__is_new_row) {
                let formatedValue = {
                    PERCENTREDUCAO: changedData.PERCENTREDUCAO || null,
                    NRCOMBINACAOCARD: changedData.NRCOMBINACAOCARD
                };
                return PlatesProvider.saveChangedData([formatedValue], 'COMBINACAOCARD');
            } else {
                return PlatesProvider.insertData([{
                    CDGRTIPOPR: changedData.CDGRTIPOPR,
                    CDFILIAL: CDFILIAL,
                    CDSERVFILI: CDSERVFILI,
                    CDFILAUXPRAT: changedData.CDFILAUXPRAT,
                    CDPRATO: changedData.CDPRATO,
                    COMB_CDGRTIPOPR: changedData.COMB_CDGRTIPOPR,
                    COMB_CDFILAUXPRAT: changedData.COMB_CDFILAUXPRAT,
                    COMB_CDPRATO: changedData.COMB_CDPRATO,
                    IDCOMBINACAO: changedData.IDCOMBINACAO_key,
                    PERCENTREDUCAO: changedData.PERCENTREDUCAO || null,
                    IDTIPORESTRICAO: IDTIPORESTRICAO,
                    NRORG: _getNRORG()
                }], 'COMBINACAOCARD');
            }
        } else {
            return Promise.resolve(_getFormatedError(changedData, validations, colName, 
                changedData.__is_new_row, changedData.lastColTouched));
        }
    };

    this.insertCombination = function(data) {
        return PlatesProvider.insertData([{
            ...data,
            CDFILIAL: _getCDFILIAL(),
            CDSERVFILI: _getCDSERVFILI(),
            IDTIPORESTRICAO: _getIDTIPORESTRICAO(),
            NRORG: _getNRORG()
        }], 'COMBINACAOCARD').
        then(r => r.dataset && r.dataset.data);
    };
    this.verificaRelatorioIA = function(nrcenario, dataCatalog, regerar) {
        return PlatesProvider.verificaRelatorioIA(nrcenario, dataCatalog, regerar);
    };

    this.getFeedbacks = function(nrcenario) {
        return PlatesProvider.getFeedbacks(nrcenario);
    };
    this.getFeedbackPlates = function(nrfeedbackcard) {
        return PlatesProvider.getFeedbackPlates(nrfeedbackcard);
    };
    this.updateFeedback = function(feedbackData) {
        return PlatesProvider.updateFeedback(feedbackData);
    };
    this.deleteFeedback = function(nrfeedbackcard) {
        return PlatesProvider.deleteFeedback(nrfeedbackcard);
    };

    this.insertFeedback = function(text, listPlates, nrcenario) {
        return PlatesProvider.insertData([{
            JUSTIFICATIVA: text,
            listPlates: listPlates,
            NRCENARIOCARD: nrcenario,
            NRORG: _getNRORG()
        }], 'FEEDBACK')
        .then(r => r.dataset && r.dataset.data);
    };
    
    this.insertAttractiveness = function(data) {
        return PlatesProvider.insertData([{
            ...data,
            CDFILIDESTINO : _getCDFILIAL()
        }], 'ADD_FILIAL_ATRATIVIDADE').
        then(r => r.dataset && r.dataset.data);
    };
    
    this.deleteAttractiveness = function() {
        return PlatesProvider.deleteData([{
            CDFILIDESTINO : _getCDFILIAL()
        }], 'DEL_FILIAL_ATRATIVIDADE').
        then(r => r.dataset && r.dataset.data);
    };

    const _numberFromBRString = (numberString) => {
        numberString = numberString && numberString.replace(',', '.');
        if(numberString && numberString[0] === '.'){
            numberString = '0' + numberString; 
        }
        return numberString;
    }; 

    this.saveConsumptionHistoryData = (changedData, colName) => {
        const isNew = !changedData.NRHISTCONSUMOPRATO;
        changedData = {...changedData, VRPECONSCARD: _numberFromBRString(changedData.VRPECONSCARD)};
        const validations = {
            CDPRATO: {f: vf.notEmpty, label: t('dish_code')},
            NMPRATO: {f: vf.withAnother(vf.notEmpty, "CDPRATO", t('dish_code')), label: ""},
            VRPECONSCARD: {f: [
                vf.rangeFloat(0.0001, 99999, t('the_reduction_percentage_field_must_be_a_number_greater_than_zero'))
            ], label: t('percentage_of_consumption')}
        };
        const validationResult = validateFields(changedData, validations);
        let resultPromise;
        if(validationResult.error) {
            resultPromise = Promise.resolve(_getFormatedError(
                changedData, validations, colName, changedData.__is_new_row, colName === 'VRPECONSCARD'
            ));
        } else if(isNew){
            resultPromise = PlatesProvider.insertData([{
                CDPRATO: changedData.CDPRATO,
                CDFILAUXPRAT: changedData.CDFILAUXPRAT,
                VRPECONSCARD: changedData.VRPECONSCARD,
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                NRORG: _getNRORG()
            }], "CONSUMPTION_HISTORY");
        } else {
            resultPromise = PlatesProvider.saveChangedData([{
                NRHISTCONSUMOPRATO: changedData.NRHISTCONSUMOPRATO,
                VRPECONSCARD: changedData.VRPECONSCARD
            }], "CONSUMPTION_HISTORY");
        }
        return resultPromise;
    };

    this.deletePreparationMethodGridData = (data) => {
        return PlatesProvider.deleteData(data.filter(el => el.NRFORMAPREPARO).map(de => {
            return { NRFORMAPREPARO: de.NRFORMAPREPARO }
        }), "MDPREPARO");
    };
    this.deleteCutTypeGridData = (data) => {
        return PlatesProvider.deleteData(data.filter(el => el.CDAPRERECE).map(de => {
            return { CDAPRERECE: de.CDAPRERECE }
        }), "TPCORTE");
    };
    this.deleteMainIngredientGridData = (data) => {
        return PlatesProvider.deleteData(data.filter(el => el.NRINGREDIENTEPRINC).map(de => {
            return { NRINGREDIENTEPRINC: de.NRINGREDIENTEPRINC }
        }), "INGRPRINC");
    };
    this.deleteTypeProteinGridData = (data) => {
        return PlatesProvider.deleteData(data.filter(el => el.NRTIPOPROTEINA).map(de => {
            return { NRTIPOPROTEINA: de.NRTIPOPROTEINA }
        }), "TPPROTEINA");
    };
    /**
     * Return parameters from plates related with 
     * selected work unit.
     */
    this.getPlatesParameters = () => {
		return Util.ifFilterSelected(PlatesProvider.getPlatesParameters);
    };

    /**
     * Return attractiveness from plates related with 
     * selected service.
     */
    this.getAttractivenessGridData = () => {
        return PlatesProvider.getAttractivenessGridData();
    };

    this.getMainIngredient = () => {
        return PlatesProvider.getMainIngredient();
    };

    this.getProteinType = () => {
        return PlatesProvider.getProteinType();
    };

    this.replicationProcedureCaller = async (replicationObject) => 
        await PlatesProvider.replicationProcedureCaller(replicationObject);


    this.getDishesFromSearch = (searchValue) => {
        return PlatesProvider.getDishesFromSearch(searchValue);
    };

    this.getCutType = () => {
        return PlatesProvider.getCutType();
    };

    this.getGroupPlates = () => {
        return PlatesProvider.getGroupPlates();
    };

    this.getPreparationMethod = () => {
        return PlatesProvider.getPreparationMethod();
    };

    this.getAttractiveness = () => {
        return PlatesProvider.getAttractivenessGridData();
    };

    this.getCombinations = () => {
        return PlatesProvider.getCombinations();
    };

    this.getPlates = (userQuery, maxResults) => {
        return PlatesProvider.getPlates(userQuery, maxResults);
    };

    this.getCombPlates = (userQuery, maxResults) => {
        return PlatesProvider.getCombPlates(userQuery, maxResults);
    };

    this.getPlateGroup = (userQuery, maxResults) => {
        return PlatesProvider.getPlateGroup(userQuery, maxResults);
    };

    this.getCombPlateGroup = (userQuery, maxResults) => {
        return PlatesProvider.getCombPlateGroup(userQuery, maxResults);
    };

    this.getSimilarPlates = ({CDPRATO = null, NMPRATO = null} = {}) => {
        return PlatesProvider.getSimilarPlates( CDPRATO, NMPRATO);
    };

    this.getConsumptionHistory = (type) => PlatesProvider.getConsumptionHistory(type);

    this.getPlatesConsumptionHistory = (query) => PlatesProvider.getPlatesConsumptionHistory(query);

    this.getRestrictionRules = () => PlatesProvider.getRestrictionRules();

    this.getPlateTypeByRestrictionRule = (NRREGRARESTREPET) => PlatesProvider.getPlateTypeByRestrictionRule(NRREGRARESTREPET);
    
    this.getIngredientsRestrictionRule = (NRREGRARESTREPET) => PlatesProvider.getIngredientsRestrictionRule(NRREGRARESTREPET);
    
    this.getPlateTypeNotInRestrictionRule = (query) => PlatesProvider.getPlateTypeNotInRestrictionRule(query);

    this.getIngredientsNotInRestrictionRule = (query, NRREGRARESTREPET) => PlatesProvider.getIngredientsNotInRestrictionRule(query, NRREGRARESTREPET);
    
    this.insertRestrictionRule = (name) => PlatesProvider.insertData([{
        CDFILIAL: _getCDFILIAL(),
        CDSERVFILI: _getCDSERVFILI(),
        NRORG: _getNRORG(), //todo: move NRORG to backend
        NMREGRARESTREPET: name
    }], "REGRAS_RESTRICAO_REPETICAO").then(response=>response.dataset && response.dataset.data);

    this.updateRestrictionRule = (NRREGRARESTREPET, name) => PlatesProvider.saveChangedData([{
        NRREGRARESTREPET,
        NMREGRARESTREPET: name
    }], "REGRAS_RESTRICAO_REPETICAO");

    this.insertPlateTypeRestrictionRule = (CDTIPOPRAT, NRREGRARESTREPET) => PlatesProvider.insertData([{
        NRREGRARESTREPET,
        CDTIPOPRAT,
        NRORG: _getNRORG()
    }], 'TIPO_PRATO_REGRAS_RESTRICAO_REPETICAO').then(response=>response.dataset && response.dataset.data && response.dataset.data[0]);

    this.removePlateTypeRestrictionRule = (data) => PlatesProvider.deleteData(data.map(d => ({
        NRRESTRICAOTPPRAT: d.NRRESTRICAOTPPRAT
    })), 'TIPO_PRATO_REGRAS_RESTRICAO_REPETICAO');

    this.removeIngredientRestrictionRule = (data) => PlatesProvider.deleteData(data.map(d => ({
        NRRESTRICAOINGRED: d.NRRESTRICAOINGRED
    })), 'INGREDIENTE_REGRAS_RESTRICAO_REPETICAO');

    this.saveIngredientRestrictionRule = (data, NRREGRARESTREPET) => {
        if(!data.NRRESTRICAOINGRED){ //is new
            return PlatesProvider.insertData([{
                NRINGREDIENTEPRINC: data.NRINGREDIENTEPRINC || null,
                IDINGREDIENTE1: data.IDINGREDIENTE1 || 'S',
                IDINGREDIENTE2: data.IDINGREDIENTE2 || 'S',
                IDDIASEGUIDO: data.IDDIASEGUIDO || 'S',
                IDMESMODIA: data.IDMESMODIA || 'S',
                NRREGRARESTREPET,
                NRORG: _getNRORG()
            }], 'INGREDIENTE_REGRAS_RESTRICAO_REPETICAO').then(response=>response.dataset && response.dataset.data && response.dataset.data[0]);
        } else {
            return PlatesProvider.saveChangedData([{
                IDINGREDIENTE1: data.IDINGREDIENTE1_key || data.IDINGREDIENTE1,
                IDINGREDIENTE2: data.IDINGREDIENTE2_key || data.IDINGREDIENTE2,
                IDDIASEGUIDO: data.IDDIASEGUIDO_key || data.IDDIASEGUIDO,
                IDMESMODIA: data.IDMESMODIA_key || data.IDMESMODIA,
                NRRESTRICAOINGRED: data.NRRESTRICAOINGRED
            }], 'INGREDIENTE_REGRAS_RESTRICAO_REPETICAO');
        }
    };

    this.removeRestrictionRule = (NRREGRARESTREPET) => {
        return PlatesProvider.deleteData({NRREGRARESTREPET}, "REGRAS_RESTRICAO_REPETICAO");
    };

    this.deleteCombinationGridData = (data) => {
        return PlatesProvider.deleteData(data.map(de => {
            return { 
                NRCOMBINACAOCARD: de.NRCOMBINACAOCARD
            }
        }), "COMBINACAOCARD");
    };

    this.deleteConsumptionHistoryGridData = (data) => {
        const CDFILIAL = _getCDFILIAL();
        const CDSERVFILI = _getCDSERVFILI();
        const DTMESCARD = _getDTMESCARD();

        return PlatesProvider.deleteData(data.map(
            ({CDFILAUXPRAT, NRHISTCONSUMOPRATO, CDPRATO}) => ({
                CDFILAUXPRAT,
                NRHISTCONSUMOPRATO,
                CDPRATO,
                CDFILIAL,
                CDSERVFILI,
                DTMESCARD
            })), 
        "CONSUMPTION_HISTORY")
    };

    this.updateConsumptionHistoryInterval = ({NRMESHISTCONS}) => {
        const CDFILIAL = _getCDFILIAL();
        const CDSERVFILI = _getCDSERVFILI();

        return PlatesProvider.saveChangedData({
            CDFILIAL,
            CDSERVFILI,
            NRMESHISTCONS
        }, 'CONSUMPTION_HISTORY_INTERVAL')
    }
    
    this.submitFile = (row, tableName) => {
        return PlatesProvider.submitFile(row, tableName);
    }
}

export default new PlatesService();
